/* A ficha do caso: dados do cliente, benefício, pastas de documento e procuração.
   É a tela mais densa do sistema. Dividida em seções para dar para achar as coisas.

   Fluxo: escolher benefício -> a lista de documentos exigidos muda sozinha ->
   escanear cada pasta -> quando ficha e obrigatórios fecham, a procuração libera. */
import { $, $$, esc, hoje, dataBR, limpaNome, toast, copiarTexto } from "../util.js";
import { S, captadores } from "../estado.js";
import { sb, BUCKET } from "../supabase.js";
import { ESPECIES, MAPA } from "../dados/especies.js";
import { ETAPAS, DOCS } from "../dados/etapas.js";
import { AREAS, BENEF, DOCS_CAT, ESTADOS_CIVIS, docsDoCaso, progresso } from "../dados/catalogo.js";
import { preparar, urlAssinada, abrirVisualizador } from "../docs/arquivos.js";
import { abrirEscaner } from "../docs/escaner.js";
import { gerarProcuracao } from "../docs/procuracao.js";
import { abrirAssinatura } from "../docs/assinatura.js";
import { comissoesDoCaso, liberarComissao, removerComissao, marcarPaga,
         ETAPAS_COMISSAO, VALOR_PADRAO, dinheiro } from "../api/comissoes.js";
import { carregar, inserirCaso, atualizarCaso, excluirCaso } from "../api/casos.js";
import { gerarLink, linkVivo, revogarLink, mensagemPortal, enderecoPortal } from "../api/portal.js";
import { kb } from "../util.js";

let pendentes=[], removidos=[];

export function abrirFicha(id,codPre){
  const c=id?S.casos.find(x=>x.id===id):null, novo=!c;
  pendentes=(c?.anexos||[]).map(a=>({...a,salvo:true}));
  removidos=[];
  const opts=ETAPAS.map(e=>`<option value="${e.id}" ${((c?c.etapa:"aberto")===e.id)?"selected":""}>${e.nome}</option>`).join("");
  const grupo=(rot,arr)=>`<optgroup label="${rot}">${arr.map(([cod,nome])=>`<option value="${cod}" ${((c?c.codigo:codPre)===cod)?"selected":""}>${cod} \u00b7 ${nome}</option>`).join("")}</optgroup>`;
  const selEsp=`<option value="">Selecione a espécie</option>`+grupo("Ativos",ESPECIES.filter(e=>e[2]))+grupo("Extintos",ESPECIES.filter(e=>!e[2]));

  const areaAtual=c?.area||"prev";
  const area=AREAS.find(a=>a.id===areaAtual)||AREAS[0];
  const optBen=`<option value="">Selecione o benefício</option>`+
    area.beneficios.map(b=>`<option value="${b.id}" ${((c?c.beneficio:"")===b.id)?"selected":""}>${b.nome}${b.cod?" · "+b.cod:""}</option>`).join("");
  const optUF=["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"]
    .map(u=>`<option value="${u}" ${((c?.uf||"AP")===u)?"selected":""}>${u}</option>`).join("");
  const optEC=`<option value="">Estado civil</option>`+ESTADOS_CIVIS.map(e=>`<option value="${e}" ${(c?.estado_civil===e)?"selected":""}>${e}</option>`).join("");
  const v=(k,pad)=>esc(c?(c[k]??""):(pad||""));

  $("#modalHost").innerHTML=`<div class="scrim" id="scrim"><div class="modal" role="dialog" aria-modal="true">
    <div class="modal-head"><h2>${novo?"Novo caso":"Ficha do caso"}</h2><button class="x" id="mX" aria-label="Fechar">&times;</button></div>
    <div class="modal-body">

      <div class="secao">
        <p class="secao-tit">Benefício <i></i></p>
        <div class="grid2">
          <div class="field"><label for="fArea">Área</label>
            <select id="fArea">${AREAS.map(a=>`<option value="${a.id}" ${a.id===areaAtual?"selected":""}>${a.nome}</option>`).join("")}</select></div>
          <div class="field"><label for="fBeneficio">Tipo de benefício</label>
            <select id="fBeneficio">${optBen}</select></div>
        </div>
      </div>

      <div class="secao">
        <p class="secao-tit">Cliente <i></i></p>
        <div class="field"><label for="fCliente">Nome completo</label>
          <input id="fCliente" type="text" value="${v("cliente")}" placeholder="Como está no RG" autocomplete="off">
          <div class="err" id="errCliente">Informe o nome do cliente.</div></div>
        <div class="grid2" style="margin-top:13px">
          <div class="field"><label for="fCpf">CPF</label>
            <input id="fCpf" type="text" inputmode="numeric" value="${v("cpf")}" placeholder="000.000.000-00"></div>
          <div class="field"><label for="fNasc">Data de nascimento</label>
            <input id="fNasc" type="date" value="${c&&c.nascimento?String(c.nascimento).slice(0,10):""}"></div>
        </div>
        <div class="grid21" style="margin-top:13px">
          <div class="field"><label for="fRg">RG</label>
            <input id="fRg" type="text" value="${v("rg")}" placeholder="Número"></div>
          <div class="field"><label for="fRgO">Órgão</label>
            <input id="fRgO" type="text" value="${v("rg_orgao")}" placeholder="SSP/AP"></div>
        </div>
        <div class="grid3" style="margin-top:13px">
          <div class="field"><label for="fNac">Nacionalidade</label>
            <input id="fNac" type="text" value="${v("nacionalidade","brasileiro(a)")}" placeholder="brasileiro(a)"></div>
          <div class="field"><label for="fEc">Estado civil</label><select id="fEc">${optEC}</select></div>
          <div class="field"><label for="fProf">Profissão</label>
            <input id="fProf" type="text" value="${v("profissao")}" placeholder="Agricultor(a), do lar..."></div>
        </div>
      </div>

      <div class="secao">
        <p class="secao-tit">Endereço <i></i></p>
        <div class="field"><label for="fEnd">Rua e número</label>
          <input id="fEnd" type="text" value="${v("endereco")}" placeholder="Rua, nº, complemento"></div>
        <div class="grid2" style="margin-top:13px">
          <div class="field"><label for="fBairro">Bairro ou comunidade</label>
            <input id="fBairro" type="text" value="${v("bairro")}"></div>
          <div class="field"><label for="fCep">CEP</label>
            <input id="fCep" type="text" inputmode="numeric" value="${v("cep")}" placeholder="68900-000"></div>
        </div>
        <div class="grid21" style="margin-top:13px">
          <div class="field"><label for="fCidade">Cidade</label>
            <input id="fCidade" type="text" value="${v("cidade","Macapá")}"></div>
          <div class="field"><label for="fUf">UF</label><select id="fUf">${optUF}</select></div>
        </div>
      </div>

      <div class="secao">
        <p class="secao-tit">Contato e acesso <i></i></p>
        <div class="grid2">
          <div class="field"><label for="fTel1">Telefone 1</label>
            <input id="fTel1" type="tel" inputmode="tel" value="${v("tel1")}" placeholder="(96) 90000-0000"></div>
          <div class="field"><label for="fTel2">Telefone 2</label>
            <input id="fTel2" type="tel" inputmode="tel" value="${v("tel2")}" placeholder="Recado ou familiar"></div>
        </div>
        <div class="field" style="margin-top:13px"><label for="fEmail">E-mail</label>
          <input id="fEmail" type="email" value="${v("email")}" placeholder="Se tiver. Não é obrigatório para a procuração"></div>
        <div class="field" style="margin-top:13px"><label for="fSenhaGov">Senha Gov.br</label>
          <div class="senha-gov">
            <input id="fSenhaGov" type="password" value="${v("senha_gov")}" placeholder="Senha do Meu INSS" autocomplete="off">
            <button type="button" class="olho" id="verGov">Mostrar</button>
          </div>
          <p class="hint" style="margin-top:6px">Fornecida pelo cliente para acompanhamento do processo. Visível apenas para você e para o administrador.</p>
        </div>
      </div>

      <div class="secao">
        <p class="secao-tit">Documentos <i></i></p>
        <div id="areaPastas"></div>
        <div id="areaPortal"></div>
      </div>

      <div class="secao">
        <p class="secao-tit">Procuração <i></i></p>
        <div id="areaProc"></div>
      </div>

      ${c?`<div class="secao">
        <p class="secao-tit">Comissão <i></i></p>
        <div id="areaComissao"></div>
      </div>`:""}

      <div class="secao">
        <p class="secao-tit">Andamento <i></i></p>
        <div class="field"><label for="fCaptador">Captador</label>
          ${S.souAdmin
            ? `<select id="fCaptador">${(S.equipe||[]).map(p=>`<option value="${p.id}" ${((c?c.dono_id:S.usuario.id)===p.id)?"selected":""}>${esc(p.nome||p.email)}${p.papel==="admin"?" (admin)":""}</option>`).join("")}</select>`
            : `<input id="fCaptador" type="text" value="${esc(S.perfil.nome||S.perfil.email)}" disabled>`}
        </div>
        <div class="grid2" style="margin-top:13px">
          <div class="field"><label for="fEntrada">Data de entrada</label>
            <input id="fEntrada" type="date" value="${c&&c.entrada?String(c.entrada).slice(0,10):hoje()}"></div>
          <div class="field"><label for="fEtapa">Situação</label><select id="fEtapa">${opts}</select></div>
        </div>
        <div class="field" style="margin-top:13px"><label>Documentos enviados</label>
          <div class="seg" id="fDoc">${Object.entries(DOCS).map(([k,x])=>`<button type="button" data-doc="${k}" aria-pressed="${((c?c.doc:"nao")===k)}"><i class="dot" style="background:${x.cor}"></i>${x.rot.replace("Doc ","")}</button>`).join("")}</div></div>
        <div class="field" style="margin-top:13px"><label for="fObs">Observação</label>
          <textarea id="fObs" placeholder="Perícia marcada, exigência pendente, número do protocolo...">${v("obs")}</textarea></div>
        ${c?`<p class="hint" style="margin-top:12px">Registrado por ${esc(c.criado_por||"\u2014")} em ${dataBR(c.criado_em)}.</p>`:""}
      </div>

    </div>
    <div class="modal-foot">
      ${(novo||!S.souAdmin)?"":'<button class="btn danger" id="mDel">Excluir</button>'}
      <div class="spacer"></div>
      <button class="btn ghost" id="mCancel">Cancelar</button>
      <button class="btn" id="mSave">${novo?"Cadastrar":"Salvar"}</button>
    </div></div></div>`;

  let doc=c?c.doc:"nao";
  $("#fDoc").addEventListener("click",e=>{
    const b=e.target.closest("[data-doc]"); if(!b) return;
    doc=b.dataset.doc; $("#fDoc").querySelectorAll("button").forEach(x=>x.setAttribute("aria-pressed",x===b));
  });

  // ---- estado vivo do caso dentro do modal ----
  const atual=()=>({...(c||{}),
    cliente:$("#fCliente").value.trim(), cpf:$("#fCpf").value.trim(), rg:$("#fRg").value.trim(),
    rg_orgao:$("#fRgO").value.trim(), nascimento:$("#fNasc").value||null,
    nacionalidade:$("#fNac").value.trim(), estado_civil:$("#fEc").value, profissao:$("#fProf").value.trim(),
    endereco:$("#fEnd").value.trim(), bairro:$("#fBairro").value.trim(),
    cidade:$("#fCidade").value.trim(), uf:$("#fUf").value, cep:$("#fCep").value.trim(),
    tel1:$("#fTel1").value.trim(), tel2:$("#fTel2").value.trim(), email:$("#fEmail").value.trim(),
    beneficio:$("#fBeneficio").value, area:$("#fArea").value,
    id:(c?c.id:"novo"), anexos:pendentes});

  $("#verGov").onclick=()=>{
    const i=$("#fSenhaGov"), b=$("#verGov"), oc=i.type==="password";
    i.type=oc?"text":"password"; b.textContent=oc?"Ocultar":"Mostrar";
  };
  $("#fArea").onchange=()=>{
    const a=AREAS.find(x=>x.id===$("#fArea").value)||AREAS[0];
    $("#fBeneficio").innerHTML=`<option value="">Selecione o benefício</option>`+
      a.beneficios.map(b=>`<option value="${b.id}">${b.nome}${b.cod?" · "+b.cod:""}</option>`).join("");
    pintarPastas(); pintarProc();
  };
  $("#fBeneficio").onchange=()=>{ pintarPastas(); pintarProc(); };
  ["fCliente","fCpf","fRg","fNasc","fEnd","fCidade","fUf","fTel1"].forEach(id=>{
    const el=$("#"+id); if(el) el.addEventListener("input",pintarProc);
  });

  // ---- pastas de documento ----
  const inSlot=document.createElement("input");
  inSlot.type="file"; inSlot.accept="image/*,application/pdf"; inSlot.hidden=true;
  document.body.appendChild(inSlot);
  const inSlotCam=document.createElement("input");
  inSlotCam.type="file"; inSlotCam.accept="image/*"; inSlotCam.capture="environment"; inSlotCam.hidden=true;
  document.body.appendChild(inSlotCam);
  let slotAtivo=null;

  function pintarPastas(){
    const cc=atual(), b=BENEF[cc.beneficio];
    const alvo=$("#areaPastas");
    if(!b){ alvo.innerHTML=`<p class="hint">Escolha o tipo de benefício para ver a lista de documentos exigidos.</p>`; return; }
    const pr=progresso(cc);
    const linha=(k,obrigatorio)=>{
      const ax=pendentes.filter(a=>a.slot===k);
      const cheio=ax.length>0, prev=ax.find(a=>a._prev)?._prev;
      /* Veio pelo portal: o escritorio precisa saber que ninguem conferiu
         essa foto na hora da colheita. */
      const doCliente=ax.some(a=>a.origem==="portal");
      return `<div class="pasta${cheio?" ok":""}" data-slot="${k}">
        <div class="mini-ic">${prev?`<img src="${prev}" alt="">`:(cheio?"OK":"\u2014")}</div>
        <div class="nm"><b>${esc(DOCS_CAT[k]||k)}</b>
          <span>${cheio?(ax.length>1?ax.length+" arquivos":"1 arquivo"):"não enviado"}</span></div>
        ${doCliente?`<span class="tag-cli" title="Enviado pelo cliente pelo portal, sem conferência do captador na hora">do cliente</span>`:""}
        ${(!cheio&&obrigatorio)?`<span class="obr">obrigatório</span>`:""}
        <button type="button" class="acao" data-add="${k}">${cheio?"Adicionar":"Escanear"}</button>
        ${cheio?`<button type="button" class="acao" data-ver="${k}">Ver</button>`:""}
      </div>`;
    };
    const outros=pendentes.filter(a=>!a.slot);
    alvo.innerHTML=`
      <div class="barra"><i style="width:${pr.pct}%"></i></div>
      <div class="barra-txt"><span>Documentos obrigatórios</span><b>${pr.feito}/${pr.total}</b></div>
      <div class="pastas" style="margin-top:13px">${b.obrig.map(k=>linha(k,true)).join("")}</div>
      ${b.opc.length?`<p class="secao-tit" style="margin:16px 0 10px;color:var(--muted)">Complementares <i></i></p>
        <div class="pastas">${b.opc.map(k=>linha(k,false)).join("")}</div>`:""}
      ${outros.length?`<p class="secao-tit" style="margin:16px 0 10px;color:var(--muted)">Outros <i></i></p>
        <div class="anexos" id="listaAnexos"></div>`:`<div class="anexos" id="listaAnexos" hidden></div>`}
      <div class="drop-acts" style="margin-top:13px"><button type="button" class="btn ghost" id="btnOutro">Anexar outro documento</button></div>`;

    alvo.querySelectorAll("[data-add]").forEach(b2=>b2.onclick=()=>{
      slotAtivo=b2.dataset.add;
      (/iPad|iPhone|iPod|Android/i.test(navigator.userAgent)?inSlotCam:inSlot).click();
    });
    alvo.querySelectorAll("[data-ver]").forEach(b2=>b2.onclick=async()=>{
      const a=pendentes.find(x=>x.slot===b2.dataset.ver);
      if(!a) return;
      if(!a.salvo) abrirVisualizador(a.nome,a.tipo,URL.createObjectURL(a._blob),false);
      else { const u=await urlAssinada(a.caminho); u?abrirVisualizador(a.nome,a.tipo,u,true):toast("Arquivo indisponível"); }
    });
    $("#btnOutro").onclick=()=>{ slotAtivo=null; inSlot.click(); };
    if(outros.length) pintarAnexos(outros);
  }

  const receberSlot=async e=>{
    const arqs=[...e.target.files]; e.target.value="";
    for(const f of arqs){
      try{
        let p;
        if(slotAtivo && String(f.type).startsWith("image/")){
          p=await abrirEscaner(f,DOCS_CAT[slotAtivo]||"Documento");
          if(!p) continue;
        } else p=await preparar(f);
        pendentes.push({id:"n"+Math.random().toString(36).slice(2),nome:p.nome,tipo:p.tipo,
          tam:p.blob.size,slot:slotAtivo,_blob:p.blob,_prev:p.preview,salvo:false});
        pintarPastas(); pintarProc();
      }catch(err){ toast(err.message||"Não deu para anexar"); }
    }
  };
  inSlot.addEventListener("change",receberSlot);
  inSlotCam.addEventListener("change",receberSlot);

  // ---- procuração ----
  function pintarProc(){
    const cc=atual(), pr=progresso(cc), alvo=$("#areaProc");
    const faltaDoc=docsDoCaso(cc).obrig.filter(k=>!pendentes.some(a=>a.slot===k));
    const faltaFicha=[];
    if(!cc.cliente) faltaFicha.push("nome"); if(!cc.cpf) faltaFicha.push("CPF");
    if(!cc.nascimento) faltaFicha.push("nascimento");
    if(!cc.endereco) faltaFicha.push("endereço"); if(!cc.cidade) faltaFicha.push("cidade");
    if(!cc.tel1) faltaFicha.push("telefone");
    if(!cc.beneficio) faltaFicha.push("benefício");
    const pronta=!faltaDoc.length&&!faltaFicha.length&&pr.total>0;
    const assinado=!!c?.assinado_em;

    alvo.innerHTML=`<div class="proc${(pronta||assinado)?" pronta":""}">
      ${assinado
        ? `<p><b>Procuração assinada</b> em ${dataBR(c.assinado_em)}${c.assinatura_modo==="rogo"?" (a rogo, com duas testemunhas)":""}.
             Código de verificação ${esc(c.assinatura_cod||"")}.</p>
           <div class="drop-acts" style="justify-content:flex-start">
             <button type="button" class="btn ghost" id="btnProc">Baixar via em branco</button>
             <button type="button" class="btn ghost" id="btnAssinar">Assinar de novo</button>
           </div>`
        : pronta
        ? `<p>Ficha e documentos completos. Gere a procuração para conferir, ou colha a assinatura do cliente agora mesmo pela tela.</p>
           <div class="drop-acts" style="justify-content:flex-start">
             <button type="button" class="btn ghost" id="btnProc">Gerar em PDF</button>
             <button type="button" class="btn" id="btnAssinar">Colher assinatura</button>
           </div>`
        : `<p>A procuração é liberada quando a ficha e os documentos obrigatórios estiverem completos.</p>
           ${faltaFicha.length?`<p class="falta-tit">Faltam dados na ficha</p>
             <div class="falta">${faltaFicha.map(t=>`<span>${esc(t)}</span>`).join("")}</div>`:""}
           ${faltaDoc.length?`<p class="falta-tit">Faltam documentos</p>
             <div class="falta">${faltaDoc.map(k=>`<span>${esc(DOCS_CAT[k]||k)}</span>`).join("")}</div>`:""}
           <button type="button" class="btn" disabled>Gerar procuração em PDF</button>`}
      ${(c?.procuracao_em&&!assinado)?`<p class="hint" style="margin:11px 0 0">Última geração: ${dataBR(c.procuracao_em)} · documento ${esc(c.procuracao_cod||"")}</p>`:""}
      ${!c?`<p class="hint" style="margin:11px 0 0">Cadastre o caso primeiro para poder colher a assinatura.</p>`:""}
    </div>`;

    const bp=$("#btnProc");
    if(bp) bp.onclick=async()=>{
      bp.disabled=true; const antes=bp.textContent; bp.textContent="Gerando...";
      try{
        const r=await gerarProcuracao(atual());
        toast("Procuração gerada: "+r.cod);
        if(c) await sb.from("casos").update({procuracao_em:new Date().toISOString(),procuracao_cod:r.cod}).eq("id",c.id);
      }catch(e){ toast("Não deu para gerar: "+(e.message||e)); }
      bp.disabled=false; bp.textContent=antes;
    };

    const ba=$("#btnAssinar");
    if(ba) ba.onclick=async()=>{
      if(!c){ toast("Cadastre o caso antes de colher a assinatura."); return; }
      const ass=await abrirAssinatura(atual(), S.usuario?.email||"");
      if(!ass) return;
      ba.disabled=true; ba.textContent="Salvando...";
      try{
        /* Gera o PDF já assinado, guarda no Storage junto dos documentos e
           registra na ficha. O arquivo fica na pasta do caso, então herda a
           mesma permissão dos outros anexos. */
        const r=await gerarProcuracao(atual(), ass);
        const caminho=`${c.id}/${Date.now()}-procuracao-assinada.pdf`;
        const up=await sb.storage.from(BUCKET).upload(caminho,r.blob,{contentType:"application/pdf"});
        if(up.error) throw up.error;
        await sb.from("anexos").insert({caso_id:c.id,nome:"Procuração assinada.pdf",
          tipo:"application/pdf",tam:r.blob.size,caminho,slot:"procuracao",
          criado_por:S.usuario?.email||""});
        await sb.from("casos").update({
          assinado_em:ass.quando, assinatura_cod:ass.codigo, assinatura_modo:ass.modo,
          procuracao_em:new Date().toISOString(), procuracao_cod:r.cod
        }).eq("id",c.id);
        Object.assign(c,{assinado_em:ass.quando,assinatura_cod:ass.codigo,assinatura_modo:ass.modo});
        toast("Assinatura registrada: "+ass.codigo);
        pintarProc();
      }catch(e){ toast("Não deu para salvar a assinatura: "+(e.message||e)); }
      ba.disabled=false; ba.textContent="Colher assinatura";
    };
  }

  /* ---------- comissão do captador ---------- */
  async function pintarComissao(){
    const alvo=$("#areaComissao"); if(!alvo||!c) return;
    let lista;
    try { lista=await comissoesDoCaso(c.id); }
    catch(e){ alvo.innerHTML=`<p class="hint">Não deu para ler as comissões: ${esc(e.message||e)}</p>`; return; }

    const cc=atual(), pr=progresso(cc);
    const docCompleta = pr.total>0 && pr.feito===pr.total;
    const total=lista.reduce((s,x)=>s+(x.registro?Number(x.registro.valor):0),0);
    const pago =lista.reduce((s,x)=>s+((x.registro&&x.registro.pago)?Number(x.registro.valor):0),0);

    alvo.innerHTML=`
      ${lista.map(e=>{
        const r=e.registro;
        const classe=r?(r.pago?"paga":"liberada"):"";
        return `<div class="com-linha ${classe}" data-etapa="${e.id}">
          <div class="nm"><b>${e.nome}</b><span>${r?(r.pago?"paga em "+dataBR(r.pago_em):"liberada em "+dataBR(r.liberado_em)):e.dica}</span></div>
          ${r?`<span class="com-valor">${dinheiro(r.valor)}</span>
               <span class="com-tag ${r.pago?"pg":"ok"}">${r.pago?"paga":"a pagar"}</span>`
             :`<span class="com-valor" style="color:var(--muted)">${dinheiro(VALOR_PADRAO)}</span>`}
          ${S.souAdmin
            ? (r?`<button type="button" class="acao" data-pagar="${r.id}" data-estado="${r.pago?1:0}">${r.pago?"Desfazer":"Marcar paga"}</button>
                  <button type="button" class="rm" data-tirar="${r.id}">Remover</button>`
                :`<button type="button" class="acao" data-liberar="${e.id}">Liberar</button>`)
            : ""}
        </div>`;
      }).join("")}
      <div class="com-total"><span>Total do caso${pago?`, sendo ${dinheiro(pago)} já pago`:""}</span><b>${dinheiro(total)}</b></div>
      ${(S.souAdmin&&docCompleta&&!lista[0].registro)
        ? `<p class="hint" style="margin-top:10px">A documentação está completa: a parcela de captação já pode ser liberada.</p>`:""}
      ${!S.souAdmin?`<p class="hint" style="margin-top:10px">Quem libera e paga as comissões é o administrador.</p>`:""}`;

    alvo.querySelectorAll("[data-liberar]").forEach(b=>b.onclick=async()=>{
      b.disabled=true;
      try{ await liberarComissao(c.id, c.dono_id, b.dataset.liberar); await pintarComissao(); toast("Comissão liberada"); }
      catch(e){ b.disabled=false; toast("Não deu para liberar: "+(e.message||e)); }
    });
    alvo.querySelectorAll("[data-pagar]").forEach(b=>b.onclick=async()=>{
      b.disabled=true;
      try{ await marcarPaga(b.dataset.pagar, b.dataset.estado!=="1"); await pintarComissao(); }
      catch(e){ b.disabled=false; toast("Não deu para atualizar: "+(e.message||e)); }
    });
    alvo.querySelectorAll("[data-tirar]").forEach(b=>b.onclick=async()=>{
      if(!confirm("Remover esta comissão?")) return;
      try{ await removerComissao(b.dataset.tirar); await pintarComissao(); }
      catch(e){ toast("Não deu para remover: "+(e.message||e)); }
    });
  }

  /* ---------- pedir documentos ao cliente ---------- */
  async function pintarPortal(){
    const alvo=$("#areaPortal"); if(!alvo) return;
    if(!c){
      alvo.innerHTML=`<p class="hint" style="margin-top:13px">Cadastre o caso primeiro para poder pedir os documentos ao cliente.</p>`;
      return;
    }

    let link=null;
    try{ link=await linkVivo(c.id); }
    catch(e){ console.warn("portal:", e); }

    const bloqueado = link && link.bloqueado_ate && new Date(link.bloqueado_ate) > new Date();

    alvo.innerHTML=`<div class="pt-cx${link?" viva":""}">
      ${link ? `
        <div class="pt-topo">
          <b>Link ativo com o cliente</b>
          <span class="cv-cod">${esc(link.codigo)}</span>
        </div>
        <p class="hint">Vale até ${dataBR(link.expira_em)}.
          ${link.aberto_em ? `Aberto pelo cliente em ${dataBR(link.aberto_em)}.` : "Ainda não foi aberto."}
          ${link.envios ? `${link.envios} envio${link.envios===1?"":"s"} até agora.` : ""}
          ${bloqueado ? "Bloqueado agora: erraram a data de nascimento três vezes seguidas. Libera sozinho em uma hora." : ""}</p>
        <div class="drop-acts" style="justify-content:flex-start">
          <button type="button" class="btn" id="ptCopiar">Copiar mensagem</button>
          <button type="button" class="btn ghost" id="ptRevogar">Revogar link</button>
        </div>`
      : `
        <p>O cliente manda as fotos pelo celular dele, sem instalar nada e sem senha. O link pergunta a data de nascimento para confirmar que é ele, e vale por 7 dias.</p>
        <div class="drop-acts" style="justify-content:flex-start">
          <button type="button" class="btn" id="ptGerar">Pedir documentos ao cliente</button>
        </div>`}
    </div>`;

    const copiar=async codigo=>{
      const ok=await copiarTexto(mensagemPortal(atual().cliente, codigo));
      toast(ok ? "Mensagem copiada, é só colar no WhatsApp" : `Link: ${enderecoPortal(codigo)}`);
    };

    const bG=$("#ptGerar");
    if(bG) bG.onclick=async()=>{
      bG.disabled=true; bG.textContent="Gerando...";
      try{
        const r=await gerarLink(c.id);
        /* Sem data de nascimento o portal nao tem como conferir quem abriu,
           entao o banco recusa e a tela explica o que fazer. */
        if(r.erro==="sem_nascimento"){
          toast("Falta a data de nascimento na ficha. É ela que o cliente digita para abrir o link.");
          $("#fNasc")?.focus();
          bG.disabled=false; bG.textContent="Pedir documentos ao cliente";
          return;
        }
        if(!r.codigo) throw new Error("o banco não devolveu o código");
        await copiar(r.codigo);
        await pintarPortal();
      }catch(e){
        bG.disabled=false; bG.textContent="Pedir documentos ao cliente";
        toast("Não deu para gerar o link: "+(e.message||e));
      }
    };

    const bC=$("#ptCopiar");
    if(bC) bC.onclick=()=>copiar(link.codigo);

    const bR=$("#ptRevogar");
    if(bR) bR.onclick=async()=>{
      if(!confirm("Revogar o link? O cliente perde o acesso na hora, e o que ele já mandou continua aqui.")) return;
      bR.disabled=true;
      try{ await revogarLink(link.codigo); await pintarPortal(); toast("Link revogado"); }
      catch(e){ bR.disabled=false; toast("Não deu para revogar: "+(e.message||e)); }
    };
  }

  pintarPastas(); pintarProc(); pintarComissao(); pintarPortal();

  const fechar=()=>{ pendentes=[]; removidos=[]; $("#modalHost").innerHTML=""; };
  $("#mX").onclick=fechar; $("#mCancel").onclick=fechar;
  $("#scrim").addEventListener("mousedown",e=>{ if(e.target.id==="scrim") fechar(); });
  document.addEventListener("keydown",function ok(e){ if(e.key==="Escape"){ fechar(); document.removeEventListener("keydown",ok);} });

  if($("#mDel")) $("#mDel").onclick=async()=>{
    if(!confirm("Excluir o caso de "+c.cliente+"? Os documentos anexados também serão apagados.")) return;
    const caminhos=(c.anexos||[]).map(a=>a.caminho).filter(Boolean);
    if(caminhos.length) await sb.storage.from(BUCKET).remove(caminhos);
    const {error}=await sb.from("casos").delete().eq("id",c.id);
    if(error){ toast("Não deu para excluir: "+error.message); return; }
    fechar(); await carregar(); toast("Caso excluído");
  };

  $("#mSave").onclick=async()=>{
    const nome=$("#fCliente").value.trim();
    if(!nome){ $("#errCliente").style.display="block"; $("#fCliente").focus(); return; }
    const b=$("#mSave"); b.disabled=true; b.textContent="Salvando...";
    let donoId, donoNome;
    if(S.souAdmin){
      donoId=$("#fCaptador").value||S.usuario.id;
      const p=S.equipe.find(x=>x.id===donoId);
      donoNome=p?(p.nome||p.email):(S.perfil.nome||S.perfil.email);
    }else{
      donoId=S.usuario.id; donoNome=S.perfil.nome||S.perfil.email;
    }
    const ben=BENEF[$("#fBeneficio").value];
    const dados={cliente:nome,captador:donoNome,dono_id:donoId,entrada:$("#fEntrada").value||null,
      etapa:$("#fEtapa").value,codigo:ben?ben.cod:"",doc,obs:$("#fObs").value.trim(),
      area:$("#fArea").value,beneficio:$("#fBeneficio").value,
      cpf:$("#fCpf").value.trim(),rg:$("#fRg").value.trim(),rg_orgao:$("#fRgO").value.trim(),
      nascimento:$("#fNasc").value||null,nacionalidade:$("#fNac").value.trim(),estado_civil:$("#fEc").value,profissao:$("#fProf").value.trim(),
      endereco:$("#fEnd").value.trim(),bairro:$("#fBairro").value.trim(),cidade:$("#fCidade").value.trim(),
      uf:$("#fUf").value,cep:$("#fCep").value.trim(),
      tel1:$("#fTel1").value.trim(),tel2:$("#fTel2").value.trim(),email:$("#fEmail").value.trim(),senha_gov:$("#fSenhaGov").value};
    try{
      let casoId=c?c.id:null;
      if(novo){
        dados.criado_por=S.usuario?.email||"";
        const r=await sb.from("casos").insert(dados).select("id").single();
        if(r.error) throw r.error;
        casoId=r.data.id;
      }else{
        const r=await sb.from("casos").update(dados).eq("id",c.id);
        if(r.error) throw r.error;
      }
      for(const rm of removidos){ await sb.from("anexos").delete().eq("id",rm.id); }
      const fora=removidos.map(r=>r.caminho).filter(Boolean);
      if(fora.length) await sb.storage.from(BUCKET).remove(fora);
      const novosAx=pendentes.filter(a=>!a.salvo);
      for(let i=0;i<novosAx.length;i++){
        const a=novosAx[i];
        b.textContent=`Enviando ${i+1}/${novosAx.length}...`;
        const caminho=`${casoId}/${Date.now()}-${limpaNome(a.nome)}`;
        const up=await sb.storage.from(BUCKET).upload(caminho,a._blob,{contentType:a.tipo,upsert:false});
        if(up.error) throw up.error;
        const ins=await sb.from("anexos").insert({caso_id:casoId,nome:a.nome,tipo:a.tipo,tam:a.tam,caminho,slot:a.slot||null,criado_por:S.usuario?.email||""});
        if(ins.error) throw ins.error;
      }
      fechar(); await carregar(); toast(novo?"Caso cadastrado":"Caso salvo");
    }catch(e){
      b.disabled=false; b.textContent=novo?"Cadastrar":"Salvar";
      toast("Não deu para salvar: "+(e.message||e));
    }
  };
  setTimeout(()=>$("#fCliente").focus(),60);
}
function pintarAnexos(lista){
  const el=$("#listaAnexos"); if(!el) return;
  const itens=lista||pendentes.filter(a=>!a.slot);
  if(!itens.length){ el.innerHTML=""; return; }
  el.innerHTML=itens.map(a=>{
    const img=String(a.tipo).startsWith("image/");
    return `<div class="anexo" data-a="${a.id}">
      <div class="ic">${img&&a._prev?`<img src="${a._prev}" alt="">`:(img?"IMG":"PDF")}</div>
      <div class="meta"><b>${esc(a.nome)}</b><span>${kb(a.tam||0)}${a.salvo?"":" \u00b7 novo"}</span></div>
      <button type="button" class="vv" data-ver>Ver</button>
      <button type="button" class="rm" data-rm>Remover</button></div>`;
  }).join("");
  el.querySelectorAll("[data-a]").forEach(row=>{
    const a=pendentes.find(x=>x.id===row.dataset.a);
    row.querySelector("[data-ver]").onclick=async()=>{
      if(!a.salvo){ abrirVisualizador(a.nome,a.tipo,URL.createObjectURL(a._blob),false); return; }
      const u=await urlAssinada(a.caminho);
      if(u) abrirVisualizador(a.nome,a.tipo,u,true); else toast("Arquivo indisponível");
    };
    row.querySelector("[data-rm]").onclick=()=>{
      if(a.salvo) removidos.push({id:a.id,caminho:a.caminho});
      pendentes=pendentes.filter(x=>x.id!==a.id); pintarAnexos();
    };
  });
}
